// Get crypto networks from constants
// Structure: cryptoNetworks = { "BTC": ["BTC"], "SOL": ["SOL", "USDT", "USDC"], ... }
// We need to find which networks support a given currency

export const getCryptoNetworks = (currency, constants) => {
  if (!constants?.cryptoNetworks || !currency) {
    return [];
  }

  const networks = [];

  // Search through all networks to find where this currency is supported
  Object.entries(constants.cryptoNetworks).forEach(([network, currencies]) => {
    if (currencies.includes(currency)) {
      networks.push(network);
    }
  });

  return networks;
};

export const isCryptoWithNetworks = (currency, constants) => {
  if (!constants?.cryptoNetworks || !currency) {
    return false;
  }

  // Check if currency exists in any network
  return Object.values(constants.cryptoNetworks).some((currencies) => currencies.includes(currency));
};

export const formatCurrencyWithNetwork = (currency, network) => {
  if (!currency) return '';
  if (!network) return currency;
  return `${currency} (${network})`;
};

export const getDefaultNetwork = (currency, constants) => {
  const networks = getCryptoNetworks(currency, constants);
  return networks.length > 0 ? networks[0] : '';
};

// Get networks that support at least one of the provided currencies
// If currencies array is empty, returns all available networks
export const getNetworksForCurrencies = (currencies, constants) => {
  if (!constants?.cryptoNetworks) {
    return [];
  }

  // If no currencies selected, return all available networks
  if (!currencies || currencies.length === 0) {
    return Object.keys(constants.cryptoNetworks).map((network) => ({
      key: network,
      value: network
    }));
  }

  // Find networks that support at least one of the selected currencies
  const availableNetworks = new Set();

  currencies.forEach((currency) => {
    const networks = getCryptoNetworks(currency, constants);
    networks.forEach((network) => availableNetworks.add(network));
  });

  return Array.from(availableNetworks).map((network) => ({
    key: network,
    value: network
  }));
};
